export default __webpack_public_path__ + "static/media/filesync.73884dc6.png";